import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/*
 * Licensed Materials - Property of IBM
 * 5724-Q36
 * (c) Copyright IBM Corp. 2020 - 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import React, { useEffect } from 'react';
import { VariableSizeList } from 'react-window';
import { DataTable } from 'carbon-components-react';
import { pkg } from '../../../settings';
var blockClass = "".concat(pkg.prefix, "--datagrid");
var TableBody = DataTable.TableBody;
var rowSizeMap = {
  xs: 24,
  sm: 32,
  md: 40,
  lg: 48,
  xl: 64,
  // TODO: deprecate the below values in next major release (v8) on carbon-components-react
  short: 32,
  compact: 24,
  normal: 48,
  tall: 64
};
var defaultRowHeight = rowSizeMap.lg;

var DatagridVirtualBody = function DatagridVirtualBody(datagridState) {
  var getTableBodyProps = datagridState.getTableBodyProps,
      rows = datagridState.rows,
      prepareRow = datagridState.prepareRow,
      onScroll = datagridState.onScroll,
      innerListRef = datagridState.innerListRef,
      _datagridState$tableH = datagridState.tableHeight,
      tableHeight = _datagridState$tableH === void 0 ? 400 : _datagridState$tableH,
      listRef = datagridState.listRef,
      rowSize = datagridState.rowSize,
      DatagridPagination = datagridState.DatagridPagination,
      page = datagridState.page,
      handleResize = datagridState.handleResize,
      withOverflowRow = datagridState.withOverflowRow;
  useEffect(function () {
    handleResize();
  }, [handleResize]);
  var rowHeight = rowSize && rowSizeMap[rowSize] || defaultRowHeight;

  if (listRef && listRef.current) {
    listRef.current.resetAfterIndex(0);
  }

  var visibleRows = DatagridPagination && page || rows;
  return /*#__PURE__*/React.createElement(TableBody, _extends({}, getTableBodyProps(), {
    onScroll: onScroll
  }), /*#__PURE__*/React.createElement(VariableSizeList, {
    height: tableHeight,
    itemCount: visibleRows.length,
    itemSize: function itemSize(index) {
      return visibleRows[index].isExpanded ? (visibleRows[index].expandedContentHeight || 0) + rowHeight : rowHeight;
    },
    estimatedItemSize: rowHeight,
    onScroll: onScroll,
    innerRef: innerListRef,
    ref: listRef,
    className: "".concat(blockClass, "__virtual-scrollbar")
  }, function (_ref) {
    var index = _ref.index,
        style = _ref.style;
    var row = visibleRows[index];
    prepareRow(row);
    return /*#__PURE__*/React.createElement("div", {
      style: _objectSpread(_objectSpread({}, style), {}, {
        overflow: withOverflowRow ? 'visible' : 'hidden'
      })
    }, row.RowRenderer(_objectSpread(_objectSpread({}, datagridState), {}, {
      row: row
    })));
  }));
};

export default DatagridVirtualBody;